const u = up.util;
up.Request.Queue = class Queue {
    constructor() {
        this.reset();
    }
    reset() {
        this._queuedRequests = [];
        this._currentRequests = [];
        this._emittedLate = false;
    }
    get allRequests() {
        return this._currentRequests.concat(this._queuedRequests);
    }
    asap(request) {
        request.runQueuedCallbacks();
        u.always(request, () => this._onRequestSettled(request));
        this._scheduleSlowTimer(request);
        this._queueRequest(request);
        queueMicrotask(() => this._poke());
    }
    promoteToForeground(request) {
        if (request.background) {
            request.background = false;
            this._scheduleSlowTimer(request);
        }
    }
    _scheduleSlowTimer(request) {
        if (!request.isTimed())
            return;
        let timeUntilLate = Math.max(request.effectiveLateTime - request.age);
        u.timer(timeUntilLate, () => this._checkForLate());
    }
    _getMaxConcurrency() {
        return u.evalOption(up.network.config.concurrency);
    }
    _hasConcurrencyLeft() {
        const maxConcurrency = this._getMaxConcurrency();
        return (maxConcurrency === -1) || (this._currentRequests.length < maxConcurrency);
    }
    get size() {
        return this.allRequests.length;
    }
    isBusy() {
        return this.size > 0;
    }
    _queueRequest(request) {
        this._queuedRequests.push(request);
    }
    _pluckNextRequest() {
        let request = u.find(this._queuedRequests, (request) => !request.background);
        request || (request = this._queuedRequests[0]);
        return u.remove(this._queuedRequests, request);
    }
    _sendRequestNow(request) {
        if (request.load()) {
            this._currentRequests.push(request);
        }
    }
    _onRequestSettled(request) {
        u.remove(this._currentRequests, request) || u.remove(this._queuedRequests, request);
        queueMicrotask(() => this._poke());
        u.task(() => this._checkForRecover());
    }
    _poke() {
        let request;
        if (this._hasConcurrencyLeft() && (request = this._pluckNextRequest())) {
            return this._sendRequestNow(request);
        }
    }
    abort(...args) {
        let [conditions = true, { except, reason, logOnce }] = u.args(args, 'val', 'options');
        let tester = up.Request.tester(conditions, { except });
        for (let list of [this._currentRequests, this._queuedRequests]) {
            const abortableRequests = u.filter(list, tester);
            for (let abortableRequest of abortableRequests) {
                if (logOnce) {
                    up.puts(...logOnce);
                    logOnce = null;
                }
                abortableRequest.abort({ reason });
                u.remove(list, abortableRequest);
            }
        }
    }
    _checkForLate() {
        if (!this._emittedLate && this._hasLateTimedRequests()) {
            this._emittedLate = true;
            up.emit('up:network:late', { log: 'Server is slow to respond' });
        }
    }
    _checkForRecover() {
        if (this._emittedLate && !this._timedRequests.length) {
            this._emittedLate = false;
            up.emit('up:network:recover', { log: 'Slow requests were loaded' });
        }
    }
    get _timedRequests() {
        return this.allRequests.filter((request) => request.isTimed());
    }
    _hasLateTimedRequests() {
        const timerTolerance = 1;
        const isLate = (request) => request.age >= (request.effectiveLateTime - timerTolerance);
        return u.some(this._timedRequests, isLate);
    }
};
